import { translateFormatter } from '@/core/localization/translate';
export const loyaltyCashbackPerentageLabel = translateFormatter<{
  cashbackPercentage: number;
}>([{
  "type": 0,
  "value": "+"
}, {
  "type": 1,
  "value": "cashbackPercentage"
}, {
  "type": 0,
  "value": "% cagnott\xE9s"
}], undefined, undefined, "en");